import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import * as d3 from 'd3';
import { IomService } from 'src/app/services/iom.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-paretoexp-chart',
  templateUrl: './paretoChartEXP.html'
})

export class ParetoChartEXPComponent {
  constructor(public iomservice: IomService, private spinner: NgxSpinnerService) { }
  @Input()
  GraphData: any;
  @Input()
  versionId: any;
  @Input()
  wordlength: any;
  @Input()
  category: any;
  @Input()
  subcategory: any;
  @Input()
  containerID: any;
  @Input()
  paretoExpand: any;

  @Output() subPareto: EventEmitter<any> = new EventEmitter();

  exp_pareto_sub = "exp_pareto_sub"
  clickName;
  subParetoData: any;
  subParetoDataLength: any;
  divWidth;
  divHeight;
  brushRange;

  Xaxis = [];
  myData = [];

  ngOnChanges() {
    this.myData = [];
    if (this.paretoExpand == true) {
      this.createBarData(this.GraphData);
      setTimeout(() => { this.RenderPareto(); }, 500);
    }
  }
  RenderPareto() {
    var data = [];
    data = this.myData;
    var containerID = this.containerID;

    var w = document.getElementById(containerID).getBoundingClientRect().width,
      h = 300//document.getElementById('container_pareto').offsetHeight;

    var margin = {
      top: 30,
      right: 50,
      bottom: 90,
      left: 50
    },
      margin2 = {
        top: h - 70,
        right: 50,
        bottom: 30,
        left: 50
      }
    var width = w - margin.left - margin.right,
      height = 300 - margin.top - margin.bottom,
      height2 = 300 - margin2.top - margin2.bottom;


    document.getElementById(containerID).innerHTML = ""
    var that = this;

    var yMaxValue = (d3.max(data, function (d) { return d.val })) / 5;
    const yValues = [0, yMaxValue, yMaxValue * 2, yMaxValue * 3, yMaxValue * 4, yMaxValue * 5];


    var expX = d3.scaleBand()
      .domain(data.map(function (d) {
        return d.name
      }))
      .range([0, width]);

    var expX2 = d3.scaleBand()
      .domain(data.map(function (d) {
        return d.name
      }))
      .range([0, width]);

    var x3 = d3.scaleLinear()
      .domain([0, data.length])
      .range([0, width]);

    var expY = d3.scaleLinear()
      .domain([d3.min(yValues), d3.max(yValues)])
      .range([height, 0]);

    var expY2 = d3.scaleLinear()
      .domain([0, d3.max(data, function (d) {
        return d.val
      })])
      .range([height2, 0]);

    var expY3 = d3.scaleLinear()
      .domain([0, 100])
      .range([height, 0]);


    var expBrush = d3.brushX()
      .extent([
        [0, 0],
        [width, height2]
      ])
      .on("end", brushed);

    var totalAmount = 0;
    for (var i = 0; i < data.length; i++) {
      totalAmount += data[i]["val"];
      data[i]['Cumulative'] = totalAmount
    }
    for (var i = 0; i < data.length; i++) {
      data[i]['Percentage'] = (data[i]['Cumulative'] / totalAmount);
      data[i]['Percentage'] = Math.round(data[i]['Percentage'] * 100);
    }

    var expSvg = d3.select("#" + containerID)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom);

    expSvg.append("defs").append("clipPath")
      .attr("id", "expClip")
      .append("rect")
      .attr("width", width)
      .attr("height", height);

    var expFocus = expSvg.append("g")
      .attr("class", "focus")
      .attr("transform", "translate(" + margin.left + "," + 20 + ")");

    var expContext = expSvg.append("g")
      .attr("class", "context")
      .attr("transform", "translate(" + margin2.left + "," + (margin2.top + 30) + ")");

    var xAxis = d3.axisBottom(expX);
    var xAxis2 = d3.axisBottom(expX2);

    expFocus.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)
      .selectAll('text')
      .style('text-anchor', 'middle')
      .attr('fill', '#015b63')
      .style('font-size', '10px')
      .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
      .style('white-space', 'nowrap')
      .style('cursor', 'default')
      .attr('y', '5')
      //.attr('dy', '0.71em')
      .attr('x', '-5')
      .attr('transform', d => 'rotate(0)')
      .text(d => {
        if (d.length > 8) {
          d = d.substring(0, 8) + '...';
        }
        return d;
      })

      .text(d => d.length > 12 ? d : null);

    expSvg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 10)
      .attr("x", 0 - (height / 1.5))
      .style("text-anchor", "middle")
      .style("fill", 'rgb(1, 91, 99)')
      .style("font-size", '12px')
      .style("font-family", 'Graphik Medium')
      .style("font-weight", 'bold')
      .text("Occurrence");

    expSvg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", width + margin.left + margin.top + 10)
      .attr("x", 0 - (height / 1.5))
      .style("text-anchor", "middle")
      .style("fill", 'rgb(1, 91, 99)')
      .style("font-size", '12px')
      .style("font-family", 'Graphik Medium')
      .style("font-weight", 'bold')
      .text("Pareto %");

    expSvg.append("text")
      .attr("transform", "rotate(0)")
      .attr("y", height + margin.left + 25)
      .attr("x", (width / 2) + margin.left)
      .style("text-anchor", "middle")
      .style("fill", 'rgb(1, 91, 99)')
      .style("font-size", '12px')
      .style("font-family", 'Graphik Medium')
      .style("font-weight", 'bold')
      .text("Keyword");





    // Add the Y Axis
    const yAxis = d3.axisLeft()
      .scale(expY)
      .tickValues(yValues)
      .tickSize(-width, 0, 0)

    expFocus.append("g")
      .classed('yaxis', true)
      .call(yAxis);
    //.ticks(7));

    expFocus.append("g")
      .attr("class", "axis")
      .attr("transform", "translate(" + [width, 0] + ")")
      .call(d3.axisRight(expY3)
        .ticks(6)
      );

    expFocus.selectAll('.domain')
      .style("opacity", "0");

    expFocus.selectAll('line')
      .attr('stroke', '#e6e6e6');


    var focus_group = expFocus.append("g");
    focus_group.attr("clip-path", "url(#expClip)");

    var rects = focus_group.selectAll('rect')
      .data(data);

    var xscale_bw = 24;
    const rx = xscale_bw / 2,
      ry = xscale_bw / 2;



    //********* Bar Chart 1 ****************
    var newRects1 = rects.enter();

    //newRects1.append('rect')
    newRects1.append('path')
      .attr('class', 'bar expmainBars')
      .attr("d", d => `M${expX(d.name) + expX.bandwidth() / 2},${expY(d.val) + ry}
			a${rx},${ry} 0 0 1 ${rx},${-ry}
			h${xscale_bw - 2 * rx}
			a${rx},${ry} 0 0 1 ${rx},${ry}
			v${height - expY(d.val) - ry}
			h${-(xscale_bw)}Z
			`)
      .style('fill', '#6DDBDC')
      .attr('opacity', 0.85)
      .on('mouseover', function (d, i) {
        d3.select(this).style('cursor', 'pointer');
        var tooltip = expSvg
          .append("g")
          .style("cursor", "pointer")
          .attr("class", "tooltip")
          .style("opacity", 1)
        tooltip.append("rect")
          .attr("width", 90)
          .attr('height', 60)
          .style('fill', '#FFFFFF')
          .style('pointer-events', 'none')
          .style('stroke', d3.select(this).style('fill'))
          .style('stroke-width', 2)
          .style('fill-opacity', 0.8);
        var textSvg = tooltip.append("text")
          .attr('x', 7)
          .attr('y', 15)
          .style('pointer-events', 'none')
          .style('fill', '#333333')
          .style('font-size', '12px')
          .style('color', '#333333');
        textSvg.append("tspan")
          .style('font-size', '11px')
          .style('pointer-events', 'none')
          .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
          .style('font-weight', 'bold')
          .text(d.name)
        textSvg.append("tspan")
          .attr('x', 7)
          .attr('dy', 15)
          .style('pointer-events', 'none')
          .style('fill', d3.select(this).style('fill'))
          .html('&#x25cf') //&#9679; //&bull;
        textSvg.append("tspan")
          .attr('dx', 0)
          .style('pointer-events', 'none')
          .style('font-size', '11px')
          .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
          .style('font-weight', 'bold')
          .style('font-weight', 'bold')
          .text(d.val)
        textSvg.append("tspan")
          .attr('x', 7)
          .attr('dy', 15)
          .style('pointer-events', 'none')
          .style('fill', 'rgb(169, 167, 251)')
          .html('&#x25cf') //&#9679; //&bull;
        textSvg.append("tspan")
          .attr('dx', 0)
          .style('pointer-events', 'none')
          .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
          .style('font-weight', 'bold')
          .text(d.Percentage.toFixed(2) + "%");
      })
      .on("mousemove", function (d) {
        d3.select(this).style('opacity', 1)
        d3.select(this).style('cursor', 'pointer');
        var mousePosition = d3.mouse(this);
        var x = mousePosition[0];// + width / 2;
        var y = mousePosition[1];// + height / 2;
        var text = d3.select(this.closest('svg')).select('.tooltip text');
        var bbox = text.node().getBBox();
        d3.select(this.closest('svg'))
          .select('.tooltip rect')
          .attr("width", bbox.width + 15)
        if (x - bbox.width / 2 < 0) {
          x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
          x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
          y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
          y = height - bbox.height / 2;
        }
        d3.select(this.closest('svg'))
          .select('.tooltip')
          .style("opacity", 1)
          .attr('transform', `translate(${x + 10}, ${y - 20})`);
      })
      .on("mouseout", function (d) {
        d3.select(this.closest('svg'))
          .select('.tooltip').style('display', 'none');
        d3.select(this.closest('svg'))
          .select(".tooltip").remove();
        d3.select(this)//.selectAll('path')
          .style("opacity", 1);
      })
      .on("click", function (d) {
        this.clickName = d.name
        that.subPareto.emit(this.clickName);
        that.getSubParetoChartData(d.name)
        document.getElementById('drillPareto').style.display = "block";
        event.stopPropagation()
      })



    var focus_group = expContext.append("g");
    focus_group.attr("clip-path", "url(#expClip)");

    var brushRects = focus_group.selectAll('rect')
      .data(data);


    //********* Parato curve *****************	
    var guide = d3.line()
      //.x(function(d, i) { if ( x(d.name) === undefined){ return 0; }else return x(d.name) + x.bandwidth()/2 }) 
      .x(function (d, i) { return expX(d.name) + expX.bandwidth() / 2 })
      .y(function (d) { return expY3(d.Percentage); })
      .defined(function (d) { return expX(d.name); })
    //.curve(d3.curveMonotoneX)				

    var line = newRects1.append('path')
      .datum(data)
      .attr('d', guide)
      .attr('class', 'Pline')
      .attr('fill', 'none')
      .attr('stroke', '#267db3')
      .attr('stroke-width', '2')
      .attr('stroke-dasharray', '5');



    //********* Brush Bar Chart ****************
    var brushRects1 = brushRects.enter();

    brushRects1.append('rect')
      .attr('class', 'bar expmainBars')
      .attr('x', function (d, i) {
        return expX2(d.name);
      })
      .attr('y', function (d, i) {
        return expY2(d.val);
      })
      .attr('height', function (d, i) {
        return height2 - expY2(d.val)
      })
      .attr('opacity', 0.85)
      .attr('width', 10)
      .attr("transform", "translate(" + 4 + ",0)")
      .style('fill', 'lightblue')
      .style('margin-left', '2px')
      .style('margin-right', '2px')

    expContext.append("g")
      .attr("class", "brush")
      .call(expBrush)
      .call(expBrush.move, this.brushRange)


    //create brush function redraw scatterplot with selection
    function brushed() {
      //if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") return; // ignore brush-by-zoom

      // get bounds of selection
      var s = d3.event.selection,
        nD = [];
      expX2.domain().forEach((d) => {
        var pos = expX2(d) + expX2.bandwidth() / 2;
        if (pos > s[0] && pos < s[1]) {
          nD.push(d);
        }
      });

      expX.domain(nD);
      if (nD.length > 6) {
        expFocus.select(".x.axis").call(xAxis)
          .selectAll('text')
          .style('text-anchor', 'end')
          .attr('fill', '#015b63')
          .style('font-size', '10px')
          .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
          .style('white-space', 'nowrap')
          .style('cursor', 'default')
          .attr('y', '5')
          //.attr('dy', '0.71em')
          .attr('x', '-5')
          .attr('transform', d => 'rotate(-45)')
          .text(d => {
            if (d.length > 8) {
              d = d.substring(0, 8) + '...';
            }
            return d;
          })
          .append('title')
          .text(d => d.length > 12 ? d : d);
      }
      else {
        expFocus.select(".x.axis").call(xAxis).selectAll('text')
          .style('text-anchor', 'middle')
          .attr('fill', '#015b63')
          .style('font-size', '10px')
          .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
          .style('white-space', 'nowrap')
          .style('cursor', 'default')
          .attr('y', '5')
          //.attr('dy', '0.71em')
          .attr('x', '-5')
          .attr('transform', d => 'rotate(0)')
          .text(d => {
            if (d.length > 8) {
              d = d.substring(0, 8) + '...';
            }
            return d;
          })
          .append('title')
          .text(d => d.length > 12 ? d : d);
      }
      var current_components = nD.length

      // ****** bar ***********

      expFocus.selectAll(".expmainBars")
        .style("opacity", function (d) {
          return expX.domain().indexOf(d.name) === -1 ? 0 : 100;
        })
        .style("display", function (d) {
          return expX.domain().indexOf(d.name) === -1 ? "none" : "block";
        })

        .attr("d", d => {
          var xValue = expX(d.name) + (expX.bandwidth() - 22) / 2;
          xValue = isNaN(xValue) ? 0 : xValue;
          return `M${xValue},${expY(d.val) + ry}
			a${rx},${ry} 0 0 1 ${rx},${-ry}
			h${xscale_bw - 2 * rx}
			a${rx},${ry} 0 0 1 ${rx},${ry}
			v${height - expY(d.val) - ry}
			h${-(xscale_bw)}Z
			`})

        .style('fill', '#6DDBDC')
        .attr('opacity', 0.85)
        .style('margin-left', '2px')
        .style('margin-right', '2px')
        .on('mouseover', function (d, i) {
          d3.select(this).style('cursor', 'pointer');
          var tooltip = expSvg
            .append("g")
            .style("cursor", "pointer")
            .attr("class", "tooltip")
            .style("opacity", 1)
          tooltip.append("rect")
            .attr("width", 90)
            .attr('height', 60)
            .style('fill', '#FFFFFF')
            .style('pointer-events', 'none')
            .style('stroke', d3.select(this).style('fill'))
            .style('stroke-width', 2)
            .style('fill-opacity', 0.8);
          var textSvg = tooltip.append("text")
            .attr('x', 7)
            .attr('y', 15)
            .style('pointer-events', 'none')
            .style('fill', '#333333')
            .style('font-size', '12px')
            .style('color', '#333333');
          textSvg.append("tspan")
            .style('font-size', '11px')
            .style('pointer-events', 'none')
            .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
            .style('font-weight', 'bold')
            .text(d.name)
          textSvg.append("tspan")
            .attr('x', 7)
            .attr('dy', 15)
            .style('pointer-events', 'none')
            .style('fill', d3.select(this).style('fill'))
            .html('&#x25cf') //&#9679; //&bull;
          textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-size', '11px')
            .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
            .style('font-weight', 'bold')
            .style('font-weight', 'bold')
            .text(d.val)
          textSvg.append("tspan")
            .attr('x', 7)
            .attr('dy', 15)
            .style('pointer-events', 'none')
            .style('fill', '#267db3')
            .html('&#x25cf') //&#9679; //&bull;
          textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
            .style('font-weight', 'bold')
            .text(d.Percentage.toFixed(2) + "%");
        })
        .on("mousemove", function (d) {
          d3.select(this).style('opacity', 1)
          d3.select(this).style('cursor', 'pointer');
          var mousePosition = d3.mouse(this);
          var x = mousePosition[0];// + width / 2;
          var y = mousePosition[1];// + height / 2;
          var text = d3.select(this.closest('svg')).select('.tooltip text');
          var bbox = text.node().getBBox();
          d3.select(this.closest('svg'))
            .select('.tooltip rect')
            .attr("width", bbox.width + 15)
          if (x - bbox.width / 2 < 0) {
            x = bbox.width / 2;
          }
          else if (width - x - bbox.width / 2 < 0) {
            x = width - bbox.width / 2;
          }
          if (y - bbox.height / 2 < 0) {
            y = bbox.height * 2;
          }
          else if (height - y - bbox.height / 2 < 0) {
            y = height - bbox.height / 2;
          }
          d3.select(this.closest('svg'))
            .select('.tooltip')
            .style("opacity", 1)
            .attr('transform', `translate(${x + 10}, ${y - 20})`);
        })
        .on("mouseout", function (d) {
          d3.select(this.closest('svg'))
            .select('.tooltip').style('display', 'none');
          d3.select(this.closest('svg'))
            .select(".tooltip").remove();
          d3.select(this)//.selectAll('path')
            .style("opacity", 1);
        })
        .on("click", function (d) {
          this.clickName = d.name
          that.subPareto.emit(this.clickName);
          that.getSubParetoChartData(d.name)
          document.getElementById('expdrillPareto').style.display = "block";
          event.stopPropagation()
        })
      //.attr('width', (width / ( current_components)) - 3)


      // ****** dot and line ***********
      expFocus.selectAll('.Pline')
        .attr("d", guide.defined(function (d) { return expX(d.name) + expX.bandwidth() / 2; }));

    }
    expFocus.selectAll('line')
      .attr('stroke', '#e6e6e6');


  }
  createBarData(data: any) {
    if (data != undefined) {
      this.Xaxis = Object.keys(data)
      if (this.Xaxis.length <= 100 && this.Xaxis.length >= 50) {
        this.brushRange = [0, 100];
      }
      else if (this.Xaxis.length < 50 && this.Xaxis.length >= 20) {
        this.brushRange = [0, 140];
      }
      else if (this.Xaxis.length < 20 && this.Xaxis.length >= 10) {
        this.brushRange = [0, 190];
      }
      else if (this.Xaxis.length < 10 && this.Xaxis.length > 1) {
        this.brushRange = [0, 220];
      }
      else if (this.Xaxis.length == 1) {
        this.brushRange = [0, 370];
      }
      else {
        this.brushRange = [0, 100];
      }
      for (var i = 0; i < this.Xaxis.length; i++) {
        this.myData.push({ name: this.Xaxis[i], val: data[this.Xaxis[i]] })
      }
    }
  }
  getSubParetoChartData(name: any) {
    this.spinner.show();
    this.iomservice.TextAnaylsisWordCloud(this.versionId, this.category, this.subcategory, 1, name).subscribe(data => {
      document.getElementById('expdrillPareto').style.display = "block";
      this.subParetoData = data;
      this.subParetoData = this.subParetoData;
      this.subParetoDataLength = Object.keys(this.subParetoData).length;
      this.spinner.hide();
    });
  }
}
